import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from '../app.globals';
export let BASE_URL;
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
 
const browserWindow = window || {};
const browserWindowEnv = browserWindow["__env"] || {};

BASE_URL = browserWindowEnv.BASE_URL;

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ApiCallService {

  constructor(public http: HttpClient) { }

  private loaderState = new BehaviorSubject<boolean>(false);
  loaderState$ = this.loaderState.asObservable();
  showLoader: boolean = true;

  showLoadingSpinner() {
    if (this.showLoader) {
      this.loaderState.next(true);
    }
  }

  hideLoadingSpinner() {
    this.loaderState.next(false);
  }

  //********************  POST REQUEST  ********************
  getState(payload: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/COMMON_SP_UserPlantAccess`;
    return this.http.post<any[]>(url, payload);
  }

  getLoanAndRecoveriesData(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/CLPMS_DamageNLose_Listing`;
    return this.http.post<any[]>(url, opts);
  }
 
  getSubContractors(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_Listing_Contractor_Filter_V1`;
    return this.http.post<any[]>(url, opts);
  }

  getSubWorkOrder(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_Listing_WorkOrder_Filter`;
    return this.http.post<any[]>(url, opts);
  }

  getLabourList(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_LabourName_Suggestion`;
    return this.http.post<any[]>(url, opts);
  }

  getRecoveryType(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/Nesting/SP_GetMasterItemListData_V2`;
    return this.http.post<any[]>(url, opts);
  }

  getDateOfRecovery(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/CLPMS_SP_PayrollMonth_By_Date`;
    return this.http.post<any[]>(url, opts);
  }

  getStatesByCountryId(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_COM_GetAllState`;
    return this.http.post<any[]>(url, opts);
  }
  
  getAllContractors(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_Listing_Contractor_Filter_V1`;
    return this.http.post<any[]>(url, httpOptions['body'] = opts);
  }
  
  getLeaveTypeData(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_Listing_LeaveTypeList`;
    return this.http.post<any[]>(url, opts);
  }

  getLeaveTypes(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_COM_GetAllLeaveTypes`;
    return this.http.post<any[]>(url, opts);
  }
  addLeave(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Contractor/AddLeaveType`;
    return this.http.post<any[]>(url, httpOptions['body'] = opts);
  }

  updateEmailID(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/ThirdpartyEmailIdChange`;
    return this.http.post<any[]>(url, httpOptions['body'] = opts);
  }

  getRealTimeHeadCount(opts): Observable<any[]> {
    const headers = opts.lastUpdateTime ? { [GLOBAL.IGNORE_LOADER]: "true" } : {};
    const url = `${BASE_URL}Common/List/SP_Dashboard_RealTime_HeadCount`;
    return this.http.post<any[]>(url, opts, { headers });
  }

  getAllInHeadCount(opts): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_DAS_InHeadCount`;
    return this.http.post(url, opts).pipe(map((response: any) => response));
  }
  
  getAllOutHeadCount(opts): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_DAS_OutHeadCount`;
    return this.http.post(url, opts).pipe(map((response: any) => response));
  }

  public getAllRequirementAndShortage(opts): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_DAS_CountLiveShortage`;
    return this.http.post(url, opts).pipe(map((response: any) => response));
  }

  getWageTypes(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/MultiTableList/MinimumWageConfigSettingList`;
    return this.http.post<any[]>(url, opts);
  }

  getWageTableList(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/CLMS_MinimumWageMasterList`;
    return this.http.post<any[]>(url, opts);
  }

  updatCompanyPlantMinimumWage(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/CLPMS_UpdatCompanyPlantMinimumWage`;
    return this.http.post<any[]>(url, opts);
  }

  updatGovtMinimumWage(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/CLPMS_UpdatGovtMinimumWage`;
    return this.http.post<any[]>(url, opts);
  }
  
  getWageMasterDetails(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/CLPMS_MinimumWageMasterDetails`;
    return this.http.post<any[]>(url, opts);
  }
  getWageMasterDetailsForEdit(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/MultiTableList/CLPMS_MinimumWageMasterDetails`;
    return this.http.post<any[]>(url, opts);
  }

  editWageMasterDetails(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/MultiTableList/ContractorWisePayrollMasterDetails`;
    return this.http.post<any[]>(url, opts);
  }
  editMinWageMasterDetails(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/MultiTableList/CLPMS_MinimumWageMasterDetails`;
    return this.http.post<any[]>(url, opts);
  }

  viewWageMasterDetails(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/MultiTableList/CLPMS_ContractorWiseMinWage_Pivot`;
    return this.http.post<any[]>(url, opts);
  }
  
  getSkill(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_COM_GetAllSkillMaster`;
    return this.http.post<any[]>(url, opts);
  }
  getZone(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_GetMasterItemListData_V2`;
    return this.http.post<any[]>(url, opts);
  }
  getArea(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_GetMasterItemListData_V2`;
    return this.http.post<any[]>(url, opts);
  }
  getCategory(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_GetMasterItemListData_V2`;
    return this.http.post<any[]>(url, opts);
  }
  getSubCategory(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_GetMasterItemListData_V2`;
    return this.http.post<any[]>(url, opts);
  }
  apiCommonInsertUpdate(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/IUDCommon`;
    return this.http.post<any[]>(url, opts);
  }
  getGrade(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_GetMasterItemListData_V2`;
    return this.http.post<any[]>(url, opts);
  }
  getQualification(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_GetMasterItemListData_V2`;
    return this.http.post<any[]>(url, opts);
  }
  getTrade(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_COM_GetAllTradeMaster_V1`;
    return this.http.post<any[]>(url, opts);
  }

  getCompany(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_Listing_CompanyMaster_Filter`;
    return this.http.post<any[]>(url, opts);
  }

  getLabourListing(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_Listing_Labour_V1`;
    return this.http.post<any[]>(url, opts);
  }

   getGrievanceData(opts: any): Observable<any[]> {
        const url = `${BASE_URL}Common/Nesting/SP_GetMasterItemListData_V2`;
        return this.http.post<any[]>(url, opts);
      }

  getPlant(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_Listing_PlantMaster_Filter`;
    return this.http.post<any[]>(url, opts);
  }

  getAutoStateBind(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_COM_GetStateList_V1`;
    return this.http.post<any[]>(url, opts);
  }

  getCountry(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_COM_GetAllCountry`;
    return this.http.post<any[]>(url, opts);
  }

  getAttendenceApproval(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/CLMS_ApprovedPendingAttendaceList`;
    return this.http.post<any[]>(url, opts);
  }

  refreshContractorAllData(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/CLMS_CorrectContractorLogin`;
    return this.http.post<any[]>(url, opts);
  }
  
  getAllDatesByRequestType(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/CLPMS_SP_RequestWiseVlidityDetails`;
    return this.http.post<any[]>(url, opts);
  }

  getAllPlantDeptUnitSecStructure(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/Nesting/SP_Listing_DepartmentSectionSubSectionPlantUnitRelationMerging`;
    return this.http.post<any[]>(url, opts);
  }

  onSubmitNewRequest(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/BulkInsertUpdateDelete/Payrol_Create_SalaryMaster`;
    return this.http.post<any[]>(url, opts);
  } 
  getMinimumWageMasterDetails(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/MinimumWageMasterDetails_4_Report`;
    return this.http.post<any[]>(url, opts);
  } 

  getLabourPunchDetails(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_LIST_LabourPunchDetails`;
    return this.http.post<any[]>(url, opts);
  } 

  checkEICApproval(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_PRT_Listing_EICApproval`;
    return this.http.post<any[]>(url, opts);
  } 

  getManpowerAllocation(opts: any): Observable<any[]> {
    const url = `${BASE_URL}ManPowerAllocation/AttendanceApprove`;
    return this.http.post<any[]>(url, opts);
  } 
  getLeaveBalanceProcess(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_Listing_LeaveTypeList_LeaveBalanceProcess`;
    return this.http.post<any[]>(url, opts);
  } 
  getPayrollMonthList(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_Listing_PayrollMonth`;
    return this.http.post<any[]>(url, opts);
  } 
  getUserAccessDetails(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/UserDataAccessDetails`;
    return this.http.post<any[]>(url, opts);
  } 
  getWorkOrderList(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/WorkorderOwnderDetails`;
    return this.http.post<any[]>(url, opts);
  } 
  getContractorWiseWorkOrder(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/CLPMS_SP_GetContracotWiseWorkOrderList`;
    return this.http.post<any[]>(url, opts);
  } 
  getAllVisitor(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_Visitor_LIsting`;
    return this.http.post<any[]>(url, opts);
  } 
  getAllSkillMaster(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_COM_GetAllSkillMaster_V1`;
    return this.http.post<any[]>(url, opts);
  } 
  getAllMinimumWageMasterList(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/CLPMS_CompanyWiseMiniumWageMasterChecklist`;
    return this.http.post<any[]>(url, opts);
  } 

  getAllMinimumWages(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/MinimumWageMaserList`;
    return this.http.post<any[]>(url, opts);
  } 

  checkMinimumWageEntry(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/DuplicateCheck_ContractorSkillWage`;
    return this.http.post<any[]>(url, opts);
  } 

  userInfoDuplicateCheck(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/COMMON_UserInfoDuplicateCheck`;
    return this.http.post<any[]>(url, opts);
  } 
  
  getTimeZonelist(opts: any): Observable<any[]> {
    const url = `${BASE_URL}Common/List/SP_COMMON_TimeZonelist`;
    return this.http.post<any[]>(url, opts);
  } 

  //********************  GET REQUEST  ********************
  
  public getContractors(excludeContractorCode: string = "", workOrderCode: any = ""): Observable<any[]> {
    const url = `${BASE_URL}Contractor/GetContractorsFilter?search=&sDate=&eDate=&selectedField=&isMain=&
    ExcludeContractor_Code=${encodeURIComponent(excludeContractorCode)}&workOrderCode=${encodeURIComponent(workOrderCode)}&contractor_Code=`;
    return this.http.get<any[]>(url).pipe(map((response: any) => response.Data.Table)
    );
  }
  
  public getWorkOrdersByContractorCode(contractorCode: number, plantcode: number): Observable<any> {
    const url = `${BASE_URL}Contractor/GetWorkOrderbyContractor?contractorcode=${contractorCode}&plantcode=${plantcode}`;
    return this.http.get<any>(url).pipe(map((response: any) => response.Data)
    );
  }

  getContractor(): Observable<any[]> {
    const url = `${BASE_URL}Common/ContractorVendorMaster`;
    return this.http.get<any[]>(url);
  }
  
  getCompanyMasterData(): Observable<any[]> {
    const url = `${BASE_URL}GlobalMaster/GetCompanyMasterData?Search=&StatusOfIndustry=&ISActive=&SDate=&EDate=&EntityType=&Legalstatus=&State=&City=&Country=`;
    return this.http.get<any[]>(url);
  }

  globalSettingCode(): Observable<any[]> {
    const url = `${BASE_URL}GlobalMaster/GetGlobalSettingData?Code=&Search=`;
    return this.http.get<any[]>(url);
  }

  getAllMenuTree(opts: any): Observable<any[]> {
    const url = `${BASE_URL}user/GetMenuTree?userId=${opts.userId}`;
    return this.http.get<any[]>(url);
  }
  
  getAllDataSet(opts): Observable<any[]> {
    const lastUpdatedTimeParam = opts.lastUpdatedTimeParam ? `&lastUpdateTime=${opts.lastUpdatedTimeParam}` : "";
    const headers = opts.lastUpdatedTimeParam ? { [GLOBAL.IGNORE_LOADER]: "true" } : {};
    const url = `${BASE_URL}Dashboard/GetAllDatScedulesNew?UserID=${opts.UserID}&StartDate=${opts.FDATE}&EndDate=${opts.TDATE}&Flag=${opts.Flag}${lastUpdatedTimeParam}`;
    return this.http.get<any[]>(url, { headers }).pipe(map(response => response));
  }
  
  getDocumentTypes() {
    return this.http.get(`${BASE_URL}Contractor/GetDocumentTypes`);
  }
  getFilterByUser() {
    return this.http.get(`${BASE_URL}Report/GetALLSavedFilterBYUserAndPageWise?User_Code=${GLOBAL.USER_ID}&Page_Code=${251}`);
  }
  
  sendEmail(opts: any): Observable<any> {
    const url = `${BASE_URL}Email/SendMail`;
    return this.http.post<any>(url, opts);
  }

}
